import { useMemo } from 'react'

import { CreateNumberMaskOptions, createNumberMask } from '@surglogs/util'

export const useNumberMask = ({
  onlyPositive,
  integer,
  scale,
  precision,
  decimalSeparators,
}: CreateNumberMaskOptions) =>
  useMemo(
    () =>
      createNumberMask({
        integer,
        precision,
        scale,
        onlyPositive,
        decimalSeparators,
      }),
    [integer, precision, scale, onlyPositive, decimalSeparators],
  )
